import R14 from "../core";
export default class ManualEntryErrorDomain extends R14.EntityDomain {
  constructor() {
    super({
      name: "manualEntryError",
    });
  }
}
